import { useNavigate } from "react-router-dom";

import "./dataTableCustom.css";
import { VscAdd } from "react-icons/vsc";

export default function AddItemButton({ data, text, goTo }) {
	const Navigate = useNavigate();

	const openDetail = () => {
		Navigate(goTo, {
			state: {
				data,
			},
		});
	};

	return (
		<div>
			<button
				className="data-table-add-item-button-custom"
				onClick={openDetail}
			>
				<VscAdd size={"16px"} className="icon-style" />
				{text}
			</button>
		</div>
	);
}
